import React from "react"
import { motion } from "framer-motion"
import Map from "./Map"
import BusSchedule from "./BusSchedule"
import CarInfo from "./CarInfo"

const EventDetails: React.FC = () => {
  return (
    <section
      id="event-details"
      className="py-10 bg-gradient-to-br from-sand-300 to-sand-300"
    >
      <div className="container-max section-padding">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-2"
        >
          <h2 className="font-wasted text-4xl font-normal text-wedding-primary mb-6">
            Detalles del evento
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {/* Event Schedule */}
            <div className="bg-cream-50 rounded-3xl p-8 shadow-lg mb-8 border border-sand-200">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-olive-300 rounded-full flex items-center justify-center">
                    <span className="text-terracotta-600 font-bold">💐</span>
                  </div>
                  <div>
                    <h4 className="font-avenir font-semibold text-gray-800">
                      Ceremonia
                    </h4>
                    <p className="font-avenir text-gray-600">12:30h</p>
                    <p className="font-avenir text-sm text-gray-500 mt-1">
                      Iglesia de San Miguel Arcángel (Morón de la Frontera)
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
                    <span className="text-beige-600 font-bold">🕺</span>
                  </div>
                  <div>
                    <h4 className="font-avenir font-semibold text-gray-800">
                      Cóctel, banquete y ¡¡fiesta!!
                    </h4>
                    <p className="font-avenir text-gray-600">
                      14:30h - ¡Hasta que el cuerpo aguante!
                    </p>
                    <p className="font-avenir text-sm text-gray-500 mt-1">
                      Hacienda Saltillo-Lasso
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
                    <span className="text-olive-600 font-bold">🚌</span>
                  </div>
                  <div>
                    <h4 className="font-avenir font-semibold text-gray-800">
                      Autobuses y Accesos
                    </h4>
                    <a
                      href="#bus-schedule"
                      onClick={(e) => {
                        e.preventDefault()
                        const element = document.getElementById("bus-schedule")
                        if (element) {
                          element.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                          })
                        }
                      }}
                      className="font-avenir text-olive-600 hover:text-olive-700 underline cursor-pointer"
                    >
                      Ver horarios, parkings y cómo llegar 
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
                    <span className="text-olive-600 font-bold">🚗</span>
                  </div>
                  <div>
                    <h4 className="font-avenir font-semibold text-gray-800">
                      Coche
                    </h4>
                    <a
                      href="#car-info"
                      onClick={(e) => {
                        e.preventDefault()
                        const element = document.getElementById("car-info")
                        if (element) {
                          element.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                          })
                        }
                      }}
                      className="font-avenir text-olive-600 hover:text-olive-700 underline cursor-pointer"
                    >
                      Ver notas de aparcamiento
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <Map />
          </motion.div>

          {/* Right Column */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="space-y-8">
              <BusSchedule />
              <CarInfo />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default EventDetails
